interface ProductExternalResponse {
    booked: boolean;
}

export const handleGeoBookedResponse = (response: ProductExternalResponse): boolean => response.booked;
